import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebarMenuOpen } from '../../../store/global-slice';
import { RootState } from '../../../store/store';
import css from './index.module.css';

interface Props {
  theme?: string;
  stateProp?: 'isSidebarMenuOpen' | 'isProfileMenuOpen';
  toggleFunc?: () => void;
}

export default function Hamburger({
  theme = '',
  stateProp = 'isSidebarMenuOpen',
  toggleFunc = toggleSidebarMenuOpen,
}: Props) {
  const dispatch = useDispatch();
  const { isSidebarMenuOpen } = useSelector((state: RootState) => ({
    isSidebarMenuOpen: state.global[stateProp],
  }));

  const toggleMenu = () => dispatch(toggleFunc());
  const hamburgerClassNames = `${css['hamburger']} ${
    css['hamburger--squeeze']
  } ${isSidebarMenuOpen && css['is-active']}`;
  const innerClassNames = `${css['hamburger-inner']} ${css[theme]}`;

  return (
    <div className={hamburgerClassNames} onClick={toggleMenu}>
      <span className={css['hamburger-box']}>
        <span className={innerClassNames} />
      </span>
    </div>
  );
}
